export function getTotalPlacedPixels(profile) {
  return Math.max(0, Number(profile?.pixelsPlaced ?? 0)) + Math.max(0, Number(profile?.pixelsPurchased ?? 0));
}

export function getPlayerLevel(totalPixels) {
  const pixels = Math.max(0, Number(totalPixels ?? 0));
  return Math.max(1, Math.floor(Math.sqrt(pixels / 25)) + 1);
}

export function getPlayerExperience(totalPixels) {
  return Math.max(0, Number(totalPixels ?? 0));
}

export function getLevelStartPixels(level) {
  const normalizedLevel = Math.max(1, Number(level ?? 1));
  return Math.max(0, 25 * Math.pow(normalizedLevel - 1, 2));
}

export function getNextLevelPixels(level) {
  const normalizedLevel = Math.max(1, Number(level ?? 1));
  return Math.max(25, 25 * Math.pow(normalizedLevel, 2));
}

export function getPlayerProgress(profile) {
  const totalPixels = getTotalPlacedPixels(profile);
  const level = getPlayerLevel(totalPixels);
  const currentLevelStart = getLevelStartPixels(level);
  const nextLevelAt = getNextLevelPixels(level);
  const progressWithinLevel = Math.max(0, totalPixels - currentLevelStart);
  const progressNeeded = Math.max(1, nextLevelAt - currentLevelStart);

  return {
    totalPixels,
    experience: getPlayerExperience(totalPixels),
    level,
    currentLevelStart,
    nextLevelAt,
    progressWithinLevel,
    progressNeeded,
    progressRatio: Math.max(0, Math.min(1, progressWithinLevel / progressNeeded)),
  };
}
